"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jobBankPersonalSuitabilityValueLabel = exports.jobBankWorkConditionsPhysicalValueLabel = exports.jobBankTransportationTravelValueLabel = exports.jobBankSecuritySafetyValueLabel = exports.jobBankAreaSpecializationValueLabel = exports.jobBankComputerTechKnowledgeValueLabel = exports.jobBankSupervisionValueLabel = exports.jobBankTasksValueLabel = exports.jobBankBudgetaryResponsibilityValueLabel = exports.jobBankWorkSettingValueLabel = exports.jobBankGreenJobValueLabel = exports.jobBankOtherBenefitsValueLabel = exports.jobBankLongTermBenefitsValueLabel = exports.jobBankFinancialBenefitsValueLabel = exports.jobBankHealthBenefitsValueLabel = exports.jobBankEmploymentTermOptionsValueLabel = exports.jobBankHoursOfWorkValueLabel = exports.jobBankStartDateTypeValueLabel = exports.jobBankPeriodOfEmploymentValueLabel = exports.jobBankWorkplaceInformationValueLabel = exports.jobBankWhoCanApplyValueLabel = exports.jobBankTargetGroupsValueLabel = exports.jobBankJobTypeValueLabel = exports.lmiaPortalTransitionPlanExemptionTypesValueLabel = exports.lmiaPortalMonthsValueLabel = exports.lmiaPortalCaregiverCareRequiredAgeGroupValueLabel = exports.lmiaPortalCaregiverBedroomFeaturesValueLabel = exports.lmiaPortalCaregiverLiveArrangementVoluntaryValueLabel = exports.lmiaPortalCaregiverLanguageCorrespondenceValueLabel = exports.lmiaPortalCaregiverAlternatePhoneValueLabel = exports.lmiaPortalSupportTFWValueLabel = exports.lmiaPortalOffFarmHousingSkilledValueLabel = exports.lmiaPortalOffFarmOnFarmHousingValueLabel = exports.lmiaPortalAgricultureCropMethodHarvestValueLabel = exports.lmiaPortalAgricultureCropTypeValueLabel = exports.lmiaPortalSAWPArrivalTypeValueLabel = exports.lmiaPortalGtsCategoryBOccupationValueLabel = exports.lmiaPortalDesignatedReferralPartnerValueLabel = exports.lmiaPortalGtsCategoryValueLabel = exports.lmiaPortalEmploymentDurationTypeValueLabel = exports.lmiaPortalMinimumEducationRequirementsValueLabel = exports.lmiaPortalLanguageCommunicateValueLabel = exports.lmiaPortalLanguageCommunicateTypeValueLabel = exports.lmiaPortalOvertimeDeterminedValueLabel = exports.jobBankProvincesValueLabel = exports.jobBankPhoneTypeValueLabel = exports.jobBankLocationTypeValueLabel = exports.jobBankSizeOfBusinessValueLabel = exports.jobBankTypeOfBusinessValueLabel = exports.jobBankIndustryValueLabel = void 0;
exports.jobBankScreeningOptionsValueLabel = exports.jobBankApplyInstructionsValueLabel = exports.jobBankLanguageRequirementValueLabel = exports.jobBankExperienceRequirementValueLabel = exports.jobBankEducationRequirementValueLabel = void 0;
exports.jobBankIndustryValueLabel = [
    {
        value: "1",
        label: "Agriculture, forestry, fishing and hunting",
    },
    {
        value: "21",
        label: "Mining and oil and gas extraction",
    },
    {
        value: "22",
        label: "Utilities",
    },
    {
        value: "23",
        label: "Construction",
    },
    {
        value: "24",
        label: "Manufacturing",
    },
    {
        value: "25",
        label: "Wholesale trade",
    },
    {
        value: "26",
        label: "Retail trade",
    },
    {
        value: "27",
        label: "Transportation and warehousing",
    },
    {
        value: "28",
        label: "Information and cultural industries",
    },
    {
        value: "29",
        label: "Finance and insurance",
    },
    {
        value: "30",
        label: "Real estate and rental and leasing",
    },
    {
        value: "31",
        label: "Professional, scientific and technical services",
    },
    {
        value: "32",
        label: "Management of Companies and Enterprises",
    },
    {
        value: "40",
        label: "Administrative and support services",
    },
    {
        value: "42",
        label: "Employment services",
    },
    {
        value: "41",
        label: "Waste management and remediation services",
    },
    {
        value: "34",
        label: "Educational services",
    },
    {
        value: "35",
        label: "Health care and social assistance",
    },
    {
        value: "36",
        label: "Arts, entertainment and recreation",
    },
    {
        value: "37",
        label: "Accommodation and food services",
    },
    {
        value: "43",
        label: "Repair and maintenance",
    },
    {
        value: "44",
        label: "Personal and laundry services",
    },
    {
        value: "45",
        label: "Religious, grant-making, civic, and professional and similar organizations",
    },
    {
        value: "46",
        label: "Private households",
    },
    {
        value: "39",
        label: "Public administration",
    },
];
exports.jobBankTypeOfBusinessValueLabel = [
    {
        value: "1",
        label: "Sole proprietor",
    },
    {
        value: "2",
        label: "Partnership",
    },
    {
        value: "3",
        label: "Corporation",
    },
    {
        value: "4",
        label: "Not applicable (e.g. employers of caregivers)",
    },
];
exports.jobBankSizeOfBusinessValueLabel = [
    {
        value: "1",
        label: "1 - 4",
    },
    {
        value: "2",
        label: "5 - 99",
    },
    {
        value: "3",
        label: "100 - 499",
    },
    {
        value: "4",
        label: "500 +",
    },
];
exports.jobBankLocationTypeValueLabel = [
    {
        value: "3",
        label: "Physical address",
    },
    {
        value: "2",
        label: "Mailing address",
    },
    {
        value: "4",
        label: "Physical & mailing address",
    },
];
exports.jobBankPhoneTypeValueLabel = [
    {
        value: "1",
        label: "Home",
    },
    {
        value: "3",
        label: "Mobile",
    },
    {
        value: "2",
        label: "Work",
    },
];
exports.jobBankProvincesValueLabel = [
    {
        value: "48",
        label: "Alberta",
    },
    {
        value: "59",
        label: "British Columbia",
    },
    {
        value: "46",
        label: "Manitoba",
    },
    {
        value: "13",
        label: "New Brunswick",
    },
    {
        value: "10",
        label: "Newfoundland and Labrador",
    },
    {
        value: "61",
        label: "Northwest Territories",
    },
    {
        value: "12",
        label: "Nova Scotia",
    },
    {
        value: "62",
        label: "Nunavut",
    },
    {
        value: "35",
        label: "Ontario",
    },
    {
        value: "11",
        label: "Prince Edward Island",
    },
    {
        value: "24",
        label: "Québec",
    },
    {
        value: "47",
        label: "Saskatchewan",
    },
    {
        value: "60",
        label: "Yukon",
    },
];
exports.lmiaPortalOvertimeDeterminedValueLabel = [
    {
        value: "HrPerDay",
        label: "Hours per day",
    },
    {
        value: "HrPerWk",
        label: "Hours per week",
    },
    {
        value: "Both",
        label: "Both",
    },
];
exports.lmiaPortalLanguageCommunicateTypeValueLabel = [
    {
        value: "Yes",
        label: "Yes",
    },
    {
        value: "No",
        label: "No",
    },
    {
        value: "ExAgr",
        label: "Exempt, primary agriculture position",
    },
];
exports.lmiaPortalLanguageCommunicateValueLabel = [
    {
        value: "English",
        label: "English",
    },
    {
        value: "French",
        label: "French",
    },
    {
        value: "EngAndFren",
        label: "English and French",
    },
    {
        value: "EngOrFren",
        label: "English or French",
    },
];
exports.lmiaPortalMinimumEducationRequirementsValueLabel = [
    {
        value: "5",
        label: "Apprenticeship diploma/certificate",
        id: "ROLE_MER_1",
    },
    {
        value: "3",
        label: "Bachelor's degree",
        id: "ROLE_MER_2",
    },
    {
        value: "4",
        label: "College level diploma/certificate",
        id: "ROLE_MER_3",
    },
    {
        value: "11",
        label: "Doctor of Medicine",
        id: "ROLE_MER_4",
    },
    {
        value: "1",
        label: "Doctorate/PhD",
        id: "ROLE_MER_5",
    },
    {
        value: "2",
        label: "Master's degree",
        id: "ROLE_MER_6",
    },
    {
        value: "9",
        label: "No formal education requirements",
        id: "ROLE_MER_7",
    },
    {
        value: "10",
        label: "Not specified by employer",
        id: "ROLE_MER_8",
    },
    {
        value: "13",
        label: "Other minimum education requirements",
        id: "ROLE_MER_9",
    },
    {
        value: "12",
        label: "Professional Degree",
        id: "ROLE_MER_10",
    },
    {
        value: "7",
        label: "Secondary school",
        id: "ROLE_MER_11",
    },
    {
        value: "6",
        label: "Trade diploma/certificate",
        id: "ROLE_MER_12",
    },
    {
        value: "8",
        label: "Vocational school diploma/certificate",
        id: "ROLE_MER_13",
    },
];
exports.lmiaPortalEmploymentDurationTypeValueLabel = [
    {
        value: "D",
        label: "Day(s)",
    },
    {
        value: "P",
        label: "Indeterminate / permanent",
    },
    {
        value: "M",
        label: "Month(s)",
    },
    {
        value: "W",
        label: "Week(s)",
    },
    {
        value: "Y",
        label: "Year(s)",
    },
];
exports.lmiaPortalGtsCategoryValueLabel = [
    {
        value: "CatA",
        label: "Category A",
    },
    {
        value: "CatB",
        label: "Category B",
    },
];
exports.lmiaPortalDesignatedReferralPartnerValueLabel = [
    {
        value: "553349",
        label: "Accelerate Okanagan",
    },
    {
        value: "553350",
        label: "Atlantic Canada Opportunities Agency",
    },
    {
        value: "553351",
        label: "BC Tech Association",
    },
    {
        value: "553352",
        label: "Burlington Economic Development Corporation",
    },
    {
        value: "553353",
        label: "Business Development Bank of Canada",
    },
    {
        value: "579891",
        label: "Calgary Economic Development",
    },
    {
        value: "553354",
        label: "Canadian Economic Development for Quebec Regions",
    },
    {
        value: "553355",
        label: "Cape Breton Partnership",
    },
    {
        value: "553356",
        label: "City of Hamiltonâ€™s Economic Development Office",
    },
    {
        value: "603316",
        label: "City of Mississauga",
    },
    {
        value: "553357",
        label: "Communitech Corporation",
    },
    {
        value: "588111",
        label: "Corporation of the town of Oakville",
    },
    {
        value: "553358",
        label: "Council of Canadian Innovators",
    },
    {
        value: "553359",
        label: "Economic Development Winnipeg",
    },
    {
        value: "553361",
        label: "Federal Economic Development Agency for Southern Ontario",
    },
    {
        value: "553362",
        label: "Genesis (Newfoundland)",
    },
    {
        value: "553363",
        label: "Global Affairs Canadaâ€™s Trade Commissioner Service",
    },
    {
        value: "553364",
        label: "Government of Alberta, Alberta Labour",
    },
    {
        value: "553365",
        label: "Government of British Columbia, Ministry of Jobs, Trade and Technology",
    },
    {
        value: "553366",
        label: "Government of Manitoba, Manitoba Education and Training",
    },
    {
        value: "579912",
        label: "Government of New Brunswick – Post-Secondary Education, Training and Labour (PETL)",
    },
    {
        value: "553367",
        label: "Government of Nova Scotia, Nova Scotia Business Inc.",
    },
    {
        value: "556326",
        label: "Government of Ontario, Ministry of Economic Development, Job Creation, and Trade – Ontario Immigrant Nominee Program",
    },
    {
        value: "556328",
        label: "Government of Ontario, Ministry of Economic Development, Job Creation, and Trade – Ontario Investment Office",
    },
    {
        value: "553368",
        label: "Government of Prince Edward Island, Island Investment Development Inc.",
    },
    {
        value: "553369",
        label: "Government of Saskatchewan, Ministry of the Economy",
    },
    {
        value: "553370",
        label: "Halifax Partnership",
    },
    {
        value: "553371",
        label: "ICT Association of Manitoba (ICTAM)",
    },
    {
        value: "553372",
        label: "Innovation, Science and Economic Development Canada - Accelerated Growth Service",
    },
    {
        value: "553374",
        label: "Invest in Canada",
    },
    {
        value: "553373",
        label: "Invest Ottawa",
    },
    {
        value: "559687",
        label: "Investissement Québec",
    },
    {
        value: "553375",
        label: "Kingston Economic Development Corporation",
    },
    {
        value: "559688",
        label: "L'Association québécoise des technologies",
    },
    {
        value: "553376",
        label: "Launch Academy",
    },
    {
        value: "553377",
        label: "London Economic Development Corporation",
    },
    {
        value: "553378",
        label: "MaRS Discovery District",
    },
    {
        value: "559683",
        label: "Montreal International",
    },
    {
        value: "553379",
        label: "National Research Council - Industrial Research Assistance Program (NRC-IRAP)",
    },
    {
        value: "553380",
        label: "Privy Council Office, Special Projects Team",
    },
    {
        value: "559685",
        label: "Quebec International",
    },
    {
        value: "553381",
        label: "Regional Municipality of Niagara",
    },
    {
        value: "553382",
        label: "Regional Municipality of York",
    },
    {
        value: "553383",
        label: "Sarnia-Lambton Economic Partnership",
    },
    {
        value: "602731",
        label: "Tech Manitoba",
    },
    {
        value: "589379",
        label: "TECHNATION Canada",
    },
    {
        value: "588814",
        label: "The Corporation of the City of Brampton",
    },
    {
        value: "588816",
        label: "The Corporation of the City of Brampton",
    },
    {
        value: "553384",
        label: "Toronto Global",
    },
    {
        value: "553385",
        label: "Vancouver Economic Commission",
    },
    {
        value: "553386",
        label: "Venn Innovation",
    },
    {
        value: "553387",
        label: "Waterloo Region Economic Development Corporation",
    },
    {
        value: "553388",
        label: "WindsorEssex Economic Development Corporation",
    },
];
exports.lmiaPortalGtsCategoryBOccupationValueLabel = [
    {
        value: "2146",
        label: "Aerospace engineers",
    },
    {
        value: "2131",
        label: "Civil engineers",
    },
    {
        value: "0213",
        label: "Computer and information systems managers",
    },
    {
        value: "2147",
        label: "Computer engineers (except software engineers and designers)",
    },
    {
        value: "2281",
        label: "Computer network technicians",
    },
    {
        value: "2174",
        label: "Computer programmers and interactive media developers",
    },
    {
        value: "2172",
        label: "Database analysts and data administrators",
    },
    {
        value: "2241",
        label: "Electrical and electronics engineering technologists and technicians",
    },
    {
        value: "2133",
        label: "Electrical and electronics engineers",
    },
    {
        value: "5241",
        label: "Graphic designers and illustrators",
    },
    {
        value: "2171",
        label: "Information systems analysts and consultants",
    },
    {
        value: "2283",
        label: "Information systems testing technicians",
    },
    {
        value: "2161",
        label: "Mathematicians, statisticians and actuaries",
    },
    {
        value: "2143",
        label: "Mining engineers",
    },
    {
        value: "5131",
        label: "Producers, directors, choreographers and related occupations",
    },
    {
        value: "2173",
        label: "Software engineers and designers",
    },
    {
        value: "2175",
        label: "Web designers and developers",
    },
];
exports.lmiaPortalSAWPArrivalTypeValueLabel = [
    {
        value: "ARRIVAL",
        label: "Direct Arrival",
    },
    {
        value: "RPLCMNT",
        label: "Direct Replacement",
    },
    {
        value: "DBLARRVL",
        label: "Double Arrival",
    },
    {
        value: "DBLTRNSFR",
        label: "Double Transfer",
    },
    {
        value: "RPLCMNTTRN",
        label: "Replacement Transfer",
    },
    {
        value: "TRANSFER",
        label: "Transfer",
    },
];
exports.lmiaPortalAgricultureCropTypeValueLabel = [
    {
        value: "Apiary",
        label: "Apiary products",
    },
    {
        value: "Bovine",
        label: "Bovine",
    },
    {
        value: "Dairy",
        label: "Dairy",
    },
    {
        value: "Duck",
        label: "Duck",
    },
    {
        value: "Flowers",
        label: "Flowers",
    },
    {
        value: "Fruits",
        label: "Fruits, vegetables (including canning/processing of products grown on the farm)",
    },
    {
        value: "Grains",
        label: "Grains",
    },
    {
        value: "Horse",
        label: "Horse",
    },
    {
        value: "MapleSyrup",
        label: "Maple Syrup",
    },
    {
        value: "Mink",
        label: "Mink",
    },
    {
        value: "Mushroom",
        label: "Mushroom",
    },
    {
        value: "Nursery",
        label: "Nursery-grown trees including Christmas trees, greenhouses, nurseries",
    },
    {
        value: "OilSeeds",
        label: "Oil Seeds",
    },
    {
        value: "PediCanSeed",
        label: "Pedigreed canola seed",
    },
    {
        value: "Poultry",
        label: "Poultry",
    },
    {
        value: "SeedCorn",
        label: "Seed corn",
    },
    {
        value: "Sheep",
        label: "Sheep",
    },
    {
        value: "Sod",
        label: "Sod",
    },
    {
        value: "Swine",
        label: "Swine",
    },
    {
        value: "Tobacco",
        label: "Tobacco",
    },
];
exports.lmiaPortalAgricultureCropMethodHarvestValueLabel = [
    {
        value: "FullyAuto",
        label: "Fully automated",
    },
    {
        value: "HandHarv",
        label: "Hand harvested",
    },
    {
        value: "NoHarvest",
        label: "Job does not require harvesting",
    },
    {
        value: "Unspec",
        label: "Not specified",
    },
    {
        value: "SemiAuto",
        label: "Semi-automated",
    },
];
exports.lmiaPortalOffFarmOnFarmHousingValueLabel = [
    {
        value: "OffSite",
        label: "Off-Site",
    },
    {
        value: "OnSite",
        label: "On-Site",
    },
];
exports.lmiaPortalOffFarmHousingSkilledValueLabel = [
    {
        value: "Lower",
        label: "Lower",
    },
    {
        value: "Higher",
        label: "Higher",
    },
];
exports.lmiaPortalSupportTFWValueLabel = [
    {
        value: "PROnly",
        label: "Support their permanent residency only",
    },
    {
        value: "WPAndPR",
        label: "Obtain a work permit and support their permanent residency",
    },
];
exports.lmiaPortalCaregiverAlternatePhoneValueLabel = [
    {
        value: "No",
        label: "No",
    },
    {
        value: "YesNrthAmr",
        label: "Yes - North American",
    },
    {
        value: "YesForeign",
        label: "Yes - Foreign",
    },
];
exports.lmiaPortalCaregiverLanguageCorrespondenceValueLabel = [
    {
        value: "EN",
        label: "English",
    },
    {
        value: "FR",
        label: "French",
    },
];
exports.lmiaPortalCaregiverLiveArrangementVoluntaryValueLabel = [
    {
        value: "Voluntary",
        label: "Voluntary",
    },
    {
        value: "Mandatory",
        label: "Mandatory",
    },
];
exports.lmiaPortalCaregiverBedroomFeaturesValueLabel = [
    {
        value: "FinBed",
        label: "Bed with mattress and bedding (ex. sheets, pillows, blankets)",
        id: "LMIA_BED_1",
    },
    {
        value: "Closet",
        label: "Closet",
        id: "LMIA_BED_2",
    },
    {
        value: "SafetyBolt",
        label: "Door that can be locked (with a safety bolt) from the inside",
        id: "LMIA_BED_3",
    },
    {
        value: "LockedDoor",
        label: "Door that can be locked from the outside, with the key provided to the TFW",
        id: "LMIA_BED_4",
    },
    {
        value: "FinCeill",
        label: "Finished ceilings",
        id: "LMIA_BED_5",
    },
    {
        value: "FinFloors",
        label: "Finished floors",
        id: "LMIA_BED_6",
    },
    {
        value: "FinWalls",
        label: "Finished walls",
        id: "LMIA_BED_7",
    },
    {
        value: "Heating",
        label: "Heating",
        id: "LMIA_BED_8",
    },
    {
        value: "Lighting",
        label: "Lighting",
        id: "LMIA_BED_9",
    },
    {
        value: "SafeWindow",
        label: "Secure exterior window that closes and locks from within",
        id: "LMIA_BED_10",
    },
];
exports.lmiaPortalCaregiverCareRequiredAgeGroupValueLabel = [
    {
        value: "ChdPerson",
        label: "Child",
    },
    {
        value: "Other",
        label: "Other",
    },
    {
        value: "EldPerson",
        label: "Elderly Person",
    },
];
exports.lmiaPortalMonthsValueLabel = [
    {
        value: "January",
        label: "January",
    },
    {
        value: "February",
        label: "February",
    },
    {
        value: "March",
        label: "March",
    },
    {
        value: "April",
        label: "April",
    },
    {
        value: "May",
        label: "May",
    },
    {
        value: "June",
        label: "June",
    },
    {
        value: "July",
        label: "July",
    },
    {
        value: "August",
        label: "August",
    },
    {
        value: "September",
        label: "September",
    },
    {
        value: "October",
        label: "October",
    },
    {
        value: "November",
        label: "November",
    },
    {
        value: "December",
        label: "December",
    },
];
exports.lmiaPortalTransitionPlanExemptionTypesValueLabel = [
    {
        value: "Crgvr",
        label: "Caregiver positions in health care institutions (specifically NOC 3012, 3233 and 3413 under two-digit NAICS 62)",
    },
    {
        value: "LmtdDrtn",
        label: "Limited duration positions, defined as:\n- The job is time-limited in nature and the employment duration may range from one day to a maximum of two years\n- There is no reasonable expectation that you could transition the position to a Canadian or permanent resident\n- The job will not be filled after the departure of the temporary foreign worker as the position will no longer exist\n- In some cases, repeat use of the specific position is the norm for the industry, but each employment duration is limited",
    },
    {
        value: "FrmPrmAg",
        label: "On-farm primary agricultural positions such as:\n- Farm managers/supervisors and specialized livestock workers (NOC 0821, 0822, 8252, and 8255); and\n- General farm workers, nursery and greenhouse workers and harvesting labourers (NOC 8431, 8432, and 8611)",
    },
    {
        value: "QbcPstn",
        label: "Positions within a specialized occupation that qualifies for Quebec's facilitated Labour Market Impact Assessment process (applicable only to the first request for the same job at the same work location",
    },
    {
        value: "SkllsTrts",
        label: "Unique skills or traits which belong to a specific individual and are not readily available in Canada",
    },
];
exports.jobBankJobTypeValueLabel = [
    {
        value: "1",
        label: "Default",
    },
    {
        value: "3",
        label: "Students",
    },
    {
        value: "4",
        label: "Interns",
    },
];
exports.jobBankTargetGroupsValueLabel = [
    {
        value: "jobPostSkillsForm:input-jobpost-youth",
        label: "Youth",
    },
    {
        value: "jobPostSkillsForm:input-jobpost-veteran",
        label: "Veterans of the Canadian Armed Forces",
    },
    {
        value: "jobPostSkillsForm:input-jobpost-visibleminority",
        label: "Visible minorities",
    },
    {
        value: "jobPostSkillsForm:input-jobpost-pwd",
        label: "Persons with disabilities",
    },
    {
        value: "jobPostSkillsForm:input-jobpost-aboriginal",
        label: "Indigenous people",
    },
    {
        value: "jobPostSkillsForm:input-jobpost-newcomer",
        label: "Newcomers to Canada",
    },
    {
        value: "jobPostSkillsForm:input-jobpost-senior",
        label: "Older workers",
    },
];
exports.jobBankWhoCanApplyValueLabel = [
    {
        value: "jobPostSkillsForm:input-jobpost-applicant-preference-canada",
        label: "Canadians and authorized workers",
    },
    {
        value: "jobPostSkillsForm:input-jobpost-applicant-preference-global",
        label: "Canadians and international candidates",
    },
];
exports.jobBankWorkplaceInformationValueLabel = [
    {
        value: "3",
        label: "Remote work unavailable\nThere is no option to work remotely. All work must be completed at the physical location.",
    },
    {
        value: "2",
        label: "Remote work available\nWork can be completed remotely or at the physical work location.",
    },
    {
        value: "4",
        label: "On the road job\nWork locations may vary. Frequent or constant travel is required from the employee.",
    },
    {
        value: "1",
        label: "Virtual job\nThere is no physical work location. All work must be completed remotely.\nImportant: This job posting will be advertised across Canada.",
    },
];
exports.jobBankPeriodOfEmploymentValueLabel = [
    {
        value: "1",
        label: "Permanent employment",
    },
    {
        value: "2",
        label: "Term or contract",
    },
    {
        value: "3",
        label: "Casual employment",
    },
    {
        value: "4",
        label: "Seasonal employment",
    },
];
exports.jobBankStartDateTypeValueLabel = [
    {
        value: "1",
        label: "Specific date",
    },
    {
        value: "2",
        label: "As soon as possible",
    },
];
exports.jobBankHoursOfWorkValueLabel = [
    {
        value: "1",
        label: "Full time",
    },
    {
        value: "2",
        label: "Part time",
    },
    {
        value: "3",
        label: "Part time leading to full time",
    },
];
exports.jobBankEmploymentTermOptionsValueLabel = [
    {
        value: "jobPostTermsForm:input-jobpost-toe-d9",
        label: "Early morning",
    },
    {
        value: "jobPostTermsForm:input-jobpost-toe-d11",
        label: "Morning",
    },
    {
        value: "jobPostTermsForm:input-jobpost-toe-d3",
        label: "Day",
    },
    {
        value: "jobPostTermsForm:input-jobpost-toe-d4",
        label: "Evening",
    },
    {
        value: "jobPostTermsForm:input-jobpost-toe-d7",
        label: "Night",
    },
    {
        value: "jobPostTermsForm:input-jobpost-toe-d6",
        label: "Weekend",
    },
    {
        value: "jobPostTermsForm:input-jobpost-toe-d5",
        label: "Shift",
    },
    {
        value: "jobPostTermsForm:input-jobpost-toe-d1",
        label: "On call",
    },
    {
        value: "jobPostTermsForm:input-jobpost-toe-d2",
        label: "Overtime",
    },
    {
        value: "jobPostTermsForm:input-jobpost-toe-d12",
        label: "Flexible hours",
    },
    {
        value: "jobPostTermsForm:input-jobpost-toe-d10",
        label: "To be determined",
    },
];
exports.jobBankHealthBenefitsValueLabel = [
    {
        value: "jobPostTermsForm:checkboxgroup4:17:checkboxitem:0:option",
        label: "Dental plan",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:17:checkboxitem:1:option",
        label: "Disability benefits",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:17:checkboxitem:2:option",
        label: "Health care plan",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:17:checkboxitem:3:option",
        label: "Paramedical services coverage",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:17:checkboxitem:4:option",
        label: "Vision care benefits",
    },
];
exports.jobBankFinancialBenefitsValueLabel = [
    {
        value: "jobPostTermsForm:checkboxgroup4:18:checkboxitem:0:option",
        label: "As per collective agreement",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:18:checkboxitem:1:option",
        label: "Bonus",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:18:checkboxitem:2:option",
        label: "Commission",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:18:checkboxitem:3:option",
        label: "Gasoline paid",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:18:checkboxitem:4:option",
        label: "Gratuities",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:18:checkboxitem:5:option",
        label: "Group insurance benefits",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:18:checkboxitem:6:option",
        label: "Life insurance",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:18:checkboxitem:7:option",
        label: "Mileage paid",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:18:checkboxitem:8:option",
        label: "Night shift premium",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:18:checkboxitem:9:option",
        label: "Pension plan",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:18:checkboxitem:10:option",
        label: "Piece work",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:18:checkboxitem:11:option",
        label: "Registered Education Savings Plan (RESP)",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:18:checkboxitem:12:option",
        label: "Registered Retirement Savings Plan (RRSP)",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:18:checkboxitem:13:option",
        label: "Stocks/shares",
    },
];
exports.jobBankLongTermBenefitsValueLabel = [
    {
        value: "jobPostTermsForm:checkboxgroup4:19:checkboxitem:0:option",
        label: "Long-term care insurance",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:19:checkboxitem:1:option",
        label: "Maternity and parental benefits",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:19:checkboxitem:2:option",
        label: "Tax-Free Savings Account (TFSA)",
    },
];
exports.jobBankOtherBenefitsValueLabel = [
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:0:option",
        label: "Deferred Profit Sharing Plan (DPSP)",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:1:option",
        label: "Free parking available",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:2:option",
        label: "Learning/training paid by employer",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:3:option",
        label: "On-site amenities",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:4:option",
        label: "On-site daycare available",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:5:option",
        label: "On-site housing options",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:6:option",
        label: "On-site recreation and activities",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:7:option",
        label: "Other benefits",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:8:option",
        label: "Paid time off (volunteering or personal days)",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:9:option",
        label: "Subsidised public transportation",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:10:option",
        label: "Team building opportunities",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:11:option",
        label: "Transportation provided by employer",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:12:option",
        label: "Parking available",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:13:option",
        label: "Travel insurance",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:14:option",
        label: "Variable or compressed work week",
    },
    {
        value: "jobPostTermsForm:checkboxgroup4:20:checkboxitem:15:option",
        label: "Wellness program",
    },
];
exports.jobBankGreenJobValueLabel = [
    {
        value: "jobPostTermsForm:j_id_32_4_eb:0:input-jobpost-gj-skills",
        label: "Yes, because the position:\nInvolves duties and responsibilities that lead to positive environmental outcomes",
    },
    {
        value: "jobPostTermsForm:j_id_32_4_eb:1:input-jobpost-gj-skills",
        label: "Yes, because the position:\nInvolves supporting green economy sectors",
    },
    {
        value: "jobPostTermsForm:j_id_32_4_eb:2:input-jobpost-gj-skills",
        label: "Yes, because the position:\nRequires specialized environmental skills or knowledge",
    },
];
exports.jobBankWorkSettingValueLabel = [
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:0:checkboxitem:0:option",
        label: "Various locations",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:0:checkboxitem:1:option",
        label: "Outside Canada",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:0:checkboxitem:2:option",
        label: "Willing to relocate",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:0:checkboxitem:3:option",
        label: "Accommodation and food services",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:0:checkboxitem:4:option",
        label: "Radio broadcasting",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:0:checkboxitem:5:option",
        label: "Relocation costs covered by employer",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:0:checkboxitem:6:option",
        label: "Retail/wholesale establishment/distribution centre",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:0:checkboxitem:7:option",
        label: "Television broadcasting",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:0:checkboxitem:8:option",
        label: "Tourism/travel services",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:0:checkboxitem:9:option",
        label: "Relocation costs not covered by employer",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:0:checkboxitem:10:option",
        label: "Education",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:0:checkboxitem:11:option",
        label: "Financial management/services",
    },
];
exports.jobBankBudgetaryResponsibilityValueLabel = [
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:1:checkboxitem:0:option",
        label: "$1,500,001 - $4,000,000",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:1:checkboxitem:1:option",
        label: "$100,001 - $500,000",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:1:checkboxitem:2:option",
        label: "$4,000,001 - $8,000,000",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:1:checkboxitem:3:option",
        label: "$500,001 - $1,500,000",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:0:checkboxgroup2:1:checkboxitem:4:option",
        label: "$8,000,001 +",
    },
];
exports.jobBankTasksValueLabel = [
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:2:checkboxitem:0:option",
        label: "Allocate material, human and financial resources to implement organizational policies and programs",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:2:checkboxitem:1:option",
        label: "Authorize and organize the establishment of major departments and associated senior staff positions",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:2:checkboxitem:2:option",
        label: "Co-ordinate the work of regions, divisions or departments",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:2:checkboxitem:3:option",
        label: "Establish financial and administrative controls; formulate and approve promotional campaigns; and approve overall human resources planning",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:2:checkboxitem:4:option",
        label: "Establish objectives for the organization and formulate or approve policies and programs",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:2:checkboxitem:5:option",
        label: "Represent the organization, or delegate representatives to act on behalf of the organization, in negotiations or other official functions",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:2:checkboxitem:6:option",
        label: "Select middle managers, directors or other executive staff; delegate the necessary authority to them and create optimum working conditions",
    },
];
exports.jobBankSupervisionValueLabel = [
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:3:checkboxitem:0:option",
        label: "1 to 2 people",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:3:checkboxitem:1:option",
        label: "3-4 people",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:3:checkboxitem:2:option",
        label: "5-10 people",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:3:checkboxitem:3:option",
        label: "11-15 people",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:3:checkboxitem:4:option",
        label: "16-20 people",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:3:checkboxitem:5:option",
        label: "More than 20 people",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:3:checkboxitem:6:option",
        label: "Working groups",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:3:checkboxitem:7:option",
        label: "Committees",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:3:checkboxitem:8:option",
        label: "Staff in various areas of responsibility",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:1:checkboxgroup2:3:checkboxitem:9:option",
        label: "Contractors",
    },
];
exports.jobBankComputerTechKnowledgeValueLabel = [
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:3:checkboxgroup2:5:checkboxitem:0:option",
        label: "Database",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:3:checkboxgroup2:5:checkboxitem:1:option",
        label: "Inventory control software",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:3:checkboxgroup2:5:checkboxitem:2:option",
        label: "MS Access",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:3:checkboxgroup2:5:checkboxitem:3:option",
        label: "MS Excel",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:3:checkboxgroup2:5:checkboxitem:4:option",
        label: "MS Office",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:3:checkboxgroup2:5:checkboxitem:5:option",
        label: "MS Outlook",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:3:checkboxgroup2:5:checkboxitem:6:option",
        label: "MS PowerPoint",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:3:checkboxgroup2:5:checkboxitem:7:option",
        label: "MS Windows",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:3:checkboxgroup2:5:checkboxitem:8:option",
        label: "MS Word",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:3:checkboxgroup2:5:checkboxitem:9:option",
        label: "SAP (FI/CO / HR / MM / OT SD)",
    },
];
exports.jobBankAreaSpecializationValueLabel = [
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:3:checkboxgroup2:6:checkboxitem:0:option",
        label: "Operations management",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:3:checkboxgroup2:6:checkboxitem:1:option",
        label: "Sales",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:3:checkboxgroup2:6:checkboxitem:2:option",
        label: "Construction",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:3:checkboxgroup2:6:checkboxitem:3:option",
        label: "Telecommunications",
    },
];
exports.jobBankSecuritySafetyValueLabel = [
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:7:checkboxitem:0:option",
        label: "Bondable",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:7:checkboxitem:1:option",
        label: "Confidential security clearance",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:7:checkboxitem:2:option",
        label: "Secret clearance",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:7:checkboxitem:3:option",
        label: "Top secret clearance",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:7:checkboxitem:4:option",
        label: "Eligible for professional liability insurance",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:7:checkboxitem:5:option",
        label: "Airport security clearance",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:7:checkboxitem:6:option",
        label: "Criminal record check",
    },
];
exports.jobBankTransportationTravelValueLabel = [
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:8:checkboxitem:0:option",
        label: "Valid driver's licence",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:8:checkboxitem:1:option",
        label: "Vehicle supplied by employer",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:8:checkboxitem:2:option",
        label: "Own vehicle",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:8:checkboxitem:3:option",
        label: "Willing to travel",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:8:checkboxitem:4:option",
        label: "Willing to travel overnight",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:8:checkboxitem:5:option",
        label: "Willing to travel regularly",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:8:checkboxitem:6:option",
        label: "Willing to travel internationally",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:8:checkboxitem:7:option",
        label: "Travel expenses paid by employer",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:8:checkboxitem:8:option",
        label: "Travel expenses not paid by employer",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:8:checkboxitem:9:option",
        label: "Transportation supplied to and from work",
    },
];
exports.jobBankWorkConditionsPhysicalValueLabel = [
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:9:checkboxitem:0:option",
        label: "Fast-paced environment",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:9:checkboxitem:1:option",
        label: "Work under pressure",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:9:checkboxitem:2:option",
        label: "Tight deadlines",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:9:checkboxitem:3:option",
        label: "Attention to detail",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:9:checkboxitem:4:option",
        label: "Large workload",
    },
];
exports.jobBankPersonalSuitabilityValueLabel = [
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:10:checkboxitem:0:option",
        label: "Excellent oral communication",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:10:checkboxitem:1:option",
        label: "Excellent written communication",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:10:checkboxitem:2:option",
        label: "Flexibility",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:10:checkboxitem:3:option",
        label: "Organized",
    },
    {
        value: "jobPostSkillsForm:j_id_33_4_6x:4:checkboxgroup2:10:checkboxitem:4:option",
        label: "Team player",
    },
];
exports.jobBankEducationRequirementValueLabel = [
    {
        value: "1",
        label: "No degree, certificate or diploma",
    },
    {
        value: "2",
        label: "Secondary (high) school graduation certificate",
    },
    {
        value: "3",
        label: "Registered Apprenticeship certificate",
    },
    {
        value: "4",
        label: "Other trades certificate or diploma",
    },
    {
        value: "5",
        label: "College, CEGEP or other non-university certificate or diploma from a program of 3 months to less than 1 year",
    },
    {
        value: "6",
        label: "College, CEGEP or other non-university certificate or diploma from a program of 1 year to 2 years",
    },
    {
        value: "7",
        label: "College/CEGEP",
    },
    {
        value: "8",
        label: "Bachelor's degree",
    },
    {
        value: "9",
        label: "Degree in medicine, dentistry, veterinary medicine or optometry",
    },
    {
        value: "10",
        label: "Master's degree",
    },
    {
        value: "11",
        label: "Earned doctorate degree",
    },
];
exports.jobBankExperienceRequirementValueLabel = [
    {
        value: "16713",
        label: "1 to less than 7 months",
    },
    {
        value: "16714",
        label: "7 months to less than 1 year",
    },
    {
        value: "16715",
        label: "1 year to less than 2 years",
    },
    {
        value: "16716",
        label: "2 years to less than 3 years",
    },
    {
        value: "16717",
        label: "3 years to less than 5 years",
    },
    {
        value: "16718",
        label: "5 years or more",
    },
    {
        value: "15182",
        label: "Will train",
    },
    {
        value: "15183",
        label: "Experience an asset",
    },
];
exports.jobBankLanguageRequirementValueLabel = [
    {
        value: "en",
        label: "English",
    },
    {
        value: "fr",
        label: "French",
    },
    {
        value: "bi",
        label: "Bilingual",
    },
    {
        value: "ef",
        label: "English or French",
    },
];
exports.jobBankApplyInstructionsValueLabel = [
    {
        value: "1",
        label: "Job reference number",
    },
    {
        value: "2",
        label: "Cover letter",
    },
    {
        value: "3",
        label: "References attesting experience",
    },
    {
        value: "4",
        label: "Letter of recommendation",
    },
    {
        value: "5",
        label: "Proof of the requested certifications",
    },
    {
        value: "6",
        label: "Link to web portfolio",
    },
    {
        value: "7",
        label: "Copy of portfolio or relevant work examples",
    },
    {
        value: "8",
        label: "Highes level of education and name of institution where it was completed",
    },
    {
        value: "9",
        label: "Copy of latest school transcript",
    },
    {
        value: "10",
        label: "Writing sample",
    },
    {
        value: "11",
        label: "Proof of student enrollment",
    },
];
exports.jobBankScreeningOptionsValueLabel = [
    {
        value: "jobPostApplyForm:checkboxgroup4:11:checkboxitem:0:option",
        label: "Are you available for shift or on-call work?",
    },
    {
        value: "jobPostApplyForm:checkboxgroup4:11:checkboxitem:1:option",
        label: "Are you available for the advertised start date?",
    },
    {
        value: "jobPostApplyForm:checkboxgroup4:11:checkboxitem:2:option",
        label: "Are you currently a student?",
    },
    {
        value: "jobPostApplyForm:checkboxgroup4:11:checkboxitem:3:option",
        label: "Are you currently legally able to work in Canada?",
    },
    {
        value: "jobPostApplyForm:checkboxgroup4:11:checkboxitem:4:option",
        label: "Are you willing to relocate for this position?",
    },
    {
        value: "jobPostApplyForm:checkboxgroup4:11:checkboxitem:5:option",
        label: "Do you currently reside in proximity to the advertised location?",
    },
    {
        value: "jobPostApplyForm:checkboxgroup4:11:checkboxitem:6:option",
        label: "Do you have previous experience in this field of employment?",
    },
    {
        value: "jobPostApplyForm:checkboxgroup4:11:checkboxitem:7:option",
        label: "Do you have the above-indicated required certifications?",
    },
    {
        value: "jobPostApplyForm:checkboxgroup4:11:checkboxitem:8:option",
        label: "Do you have the necessary equipment for remote work (i.e. internet, home office, etc.)?",
    },
    {
        value: "jobPostApplyForm:checkboxgroup4:11:checkboxitem:9:option",
        label: "What is the highest level of study you have completed?",
    },
    {
        value: "jobPostApplyForm:checkboxgroup4:11:checkboxitem:10:option",
        label: "What is your current field of study?",
    },
    {
        value: "jobPostApplyForm:checkboxgroup4:11:checkboxitem:11:option",
        label: "What is your current level of study?",
    },
];
